import React, { useMemo } from 'react'
import { Box, Button, Modal, Typography } from '@mui/material'
import { messageStyle, modalStyle, titleStyle } from './ConfirmationDialog.styles'
import { Trans } from 'react-i18next'

type ConfirmationDialogProps = {
	children?: React.ReactNode
	action: () => void | Promise<void>
	onClose: () => void
	open: boolean
	dismiss?: () => void
	dismissible?: boolean
	acceptDisabled?: boolean
	i18nPrimaryLabel?: string
	i18nSecondaryLabel?: string
	i18nDismissLabel?: string
	i18nTitle?: string
	i18nDescription?: string
	titleValues?: Record<string, string>
	descriptionValues?: Record<string, string>
}

export default function ConfirmationDialog({
	children,
	action,
	onClose,
	open,
	dismiss,
	dismissible,
	acceptDisabled,
	i18nPrimaryLabel,
	i18nSecondaryLabel,
	i18nDismissLabel,
	i18nTitle,
	i18nDescription,
	titleValues,
	descriptionValues,
}: ConfirmationDialogProps) {
	const primaryLabel = useMemo(
		() => (i18nPrimaryLabel ? i18nPrimaryLabel : 'confirmation_dialog.cancel'),
		[i18nPrimaryLabel],
	)
	const secondaryLabel = useMemo(
		() => (i18nSecondaryLabel ? i18nSecondaryLabel : 'confirmation_dialog.accept'),
		[i18nSecondaryLabel],
	)
	const dismissLable = useMemo(
		() => (i18nDismissLabel ? i18nDismissLabel : 'confirmation_dialog.dismiss'),
		[i18nDismissLabel],
	)
	return (
		<Modal open={open} aria-labelledby="modal-title" aria-describedby="modal-description">
			<Box sx={modalStyle}>
				{children}
				{!children && (
					<>
						<Typography id="modal-title" variant="h6" component="h2" sx={titleStyle}>
							<Trans i18nKey={i18nTitle} values={titleValues} components={{ bold: <b /> }} />
						</Typography>
						<Typography id="modal-description" variant="h6" component="p" sx={messageStyle}>
							<Trans i18nKey={i18nDescription} values={descriptionValues} components={{ bold: <b /> }} />
						</Typography>
					</>
				)}
				{!dismissible && (
					<Box sx={{ marginTop: 'auto', marginLeft: 'auto' }}>
						<Button variant="outlined" onClick={action} sx={{ m: 1 }} disabled={acceptDisabled}>
							<Trans i18nKey={secondaryLabel} />
						</Button>
						<Button variant="contained" onClick={onClose} sx={{ m: 1 }}>
							<Trans i18nKey={primaryLabel} />
						</Button>
					</Box>
				)}
				{dismissible && (
					<Box sx={{ marginTop: 'auto', width: '100%' }}>
						<Button variant="contained" onClick={dismiss ? dismiss : action} sx={{ m: 1, width: '100%' }}>
							<Trans i18nKey={dismissLable} />
						</Button>
					</Box>
				)}
			</Box>
		</Modal>
	)
}
